// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getCompanyActionsPending: false,
  getCompanyActionsError: null,
  Companymessage:undefined,
  userModalVisible:false,
  changeCompanyActionsPending: false,
  changeCompanyActionsError: null,
  userCompany:{},
  frui_zzzzList:{},
  frui_zzzzPage:1,
  frui_zzzzSize:10,
  frui_zzzzTotal:0,
  frui_zzzzById:{},
  frui_zzzzModalVisible:false,
  currentFrui_zzzz:{},
  getFrui_zzzzListPending: false,
  getFrui_zzzzListError: null,
  submitFrui_zzzzPending: false,
  submitFrui_zzzzError: null,
  deleteFrui_zzzzPending: false,
  deleteFrui_zzzzError: null,
  frui_qpfjList:[],
  frui_qpfjPage:1,
  frui_qpfjSize:10,
  frui_qpfjTotal:0,
  frui_qpfjById:{},
  frui_qpfjModalType:"create",
  frui_qpfjModalVisible:false,
  currentFrui_qpfj:{},
  getFrui_qpfjListPending: false,
  getFrui_qpfjListError: null,
  submitFrui_qpfjPending: false,
  submitFrui_qpfjError: null,
  deleteFrui_qpfjPending: false,
  deleteFrui_qpfjError: null,
  frui_qpbzList:[],
  frui_qpbzPage:1,
  frui_qpbzSize:10,
  frui_qpbzTotal:0,
  frui_qpbzById:{},
  frui_qpbzModalType:"create",
  frui_qpbzModalVisible:false,
  currentFrui_qpbz:{},
  getFrui_qpbzListPending: false,
  getFrui_qpbzListError: null,
  submitFrui_qpbzPending: false,
  submitFrui_qpbzError: null,
  deleteFrui_qpbzPending: false,
  deleteFrui_qpbzError: null,
  frui_qpxhList:[],
  frui_qpxhPage:1,
  frui_qpxhSize:10,
  frui_qpxhTotal:0,
  frui_qpxhById:{},
  frui_qpxhModalType:"create",
  frui_qpxhModalVisible:false,
  currentFrui_qpxh:{},
  getFrui_qpxhListPending: false,
  getFrui_qpxhListError: null,
  submitFrui_qpxhPending: false,
  submitFrui_qpxhError: null,
  deleteFrui_qpxhPending: false,
  deleteFrui_qpxhError: null,
  frui_pfbzList:[],
  frui_pfbzPage:1,
  frui_pfbzSize:10,
  frui_pfbzTotal:0,
  frui_pfbzById:{},
  frui_pfbzModalType:"create",
  frui_pfbzModalVisible:false,
  currentFrui_pfbz:{},
  getFrui_pfbzListPending: false,
  getFrui_pfbzListError: null,
  submitFrui_pfbzPending: false,
  submitFrui_pfbzError: null,
  deleteFrui_pfbzPending: false,
  deleteFrui_pfbzError: null,
  frui_pfxhList:[],
  frui_pfxhPage:1,
  frui_pfxhSize:10,
  frui_pfxhTotal:0,
  frui_pfxhById:{},
  frui_pfxhModalType:"create",
  frui_pfxhModalVisible:false,
  currentFrui_pfxh:{},
  getFrui_pfxhListPending: false,
  getFrui_pfxhListError: null,
  submitFrui_pfxhPending: false,
  submitFrui_pfxhError: null,
  deleteFrui_pfxhPending: false,
  deleteFrui_pfxhError: null,
  userchooseCurrentFrui_zzzzModalVisible:false,
  userchooseCurrentFrui_zzzzCompany:{},
  fruiPfxhtypeTestsModalVisible:false,
  fruiPfxhtypeTestsModalMessage:{},
  currentFrui_pfxhTypeTests:{},
  submitFruiPfxhTypeTestsPending: false,
  submitFruiPfxhTypeTestsError: null,
  uploadingYyzzActionsPending: false,
  uploadingYyzzActionsError: null,
  uploadingSealActionsPending: false,
  uploadingSealActionsError: null,
  uploadingXkzActionsPending: false,
  uploadingXkzActionsError: null,
  getAllQppzListPending: false,
  getAllQppzListError: null,
  getAllQppzList:[],
  getAllQppzListId:{},
  getAllMakeUnitActionsPending: false,
  getAllMakeUnitActionsError: null,
  getAllMakeUnitList:[],
  getAllMakeUnitId:{},
  getQueryQpxxIdActionsPending: false,
  getQueryQpxxIdActionsError: null,
  getQueryQpxxIdMessage:{},
  hadleTongBuActionsPending: false,
  hadleTongBuActionsError: null,
  getTempFileListActionPending: false,
  getTempFileListActionError: null,
  getTempFileListTotal: 0,
  tempFilesPage: 1,
  tempFilesById: {},
  tempFilesList: [],
  tempFilesSize: 10,
  tempFilesTotal: 0,
  delTempFileActionPending: false,
  delTempFileActionError: null,
  visbileAddModal: false,
  addTempFileActionPending: false,
  addTempFileActionError: null,
  frui_qppzList:[],
  frui_qppzPage:1,
  frui_qppzSize:10,
  frui_qppzTotal:0,
  frui_qppzById:{},
  frui_qppzModalType:"create",
  frui_qppzModalVisible:false,
  currentFrui_qppz:{},
  getFrui_qppzListPending: false,
  getFrui_qppzListError: null,
  submitFrui_qppzPending: false,
  submitFrui_qppzError: null,
  deleteFrui_qppzPending: false,
  deleteFrui_qppzError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/user/redux/initialState.js